// Demo-only member state kept in this browser. No account is created on any server.
const KEY = "altitude_demo_member";

const DEFAULTS = {
  country: "FR",
  city: "CDG",
  dream: "",
  email: "",
  method: "email",
  promoOptIn: false,
  plan: "",
  trialStart: "",
  cancelled: false,
};

export const getMember = () => {
  try {
    return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || "{}") };
  } catch {
    return { ...DEFAULTS };
  }
};

export const saveMember = (patch) => {
  const next = { ...getMember(), ...patch };
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
};

export const trialEndDate = (member) => {
  const start = member.trialStart ? new Date(member.trialStart) : new Date();
  const end = new Date(start);
  end.setDate(end.getDate() + 7);
  return end.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
};
